import { Link } from '@reach/router';
import React from 'react';

const isActive = ({ isCurrent }) => {
    return isCurrent ? { className: "active" } : {}
}

const LinkCustom = (props: LinkCustomProps) => {

    return <Link className="nav-link waves-effect waves-light" getProps={isActive} to={props.to}>{props.dictionaryTitle}</Link>
};

interface LinkCustomProps {
    dictionaryTitle: string,
    to: string
}
export default LinkCustom;